import { FC } from 'react';
import classNames from 'classnames';

import { CloudinaryImage } from 'components/common/CloudinaryImage';
import { Listing, StyledComponent } from 'types';
import { getListingTitleTruncated } from 'utils/text-helpers';

export const WatchItemTestIds = {
  container: 'watch-item-container',
  title: 'watch-item-title',
  image: 'watch-item-image'
};

export type WatchItemProps = {
  listing: Listing;
  titleClassName?: string;
  textContentClassName?: string;
  extraTitleInfo?: React.ReactNode;
  rightLabel?: React.ReactNode;
  onClick?: () => void;
} & StyledComponent;

export const WatchItem: FC<WatchItemProps> = ({
  listing,
  extraTitleInfo,
  rightLabel,
  className,
  onClick,
  titleClassName = 'text-light',
  textContentClassName
}) => {
  const titleTruncated = getListingTitleTruncated(listing, { lines: 2 });
  const listingImageUrl = listing.images?.find(i => i.type === 'FRONT')?.image.url;
  const imageUrl = listingImageUrl || listing.model?.images[0]?.url || 'model_placeholder.png';

  return (
    <div
      data-testid={WatchItemTestIds.container}
      className={classNames(
        'd-flex justify-content-between align-items-center fw-bold text-primary line-height-12px',
        className
      )}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <div className='d-flex align-self-center'>
        <div>
          <CloudinaryImage
            priority
            alt='Watch Image'
            sizes='5vw'
            className='rounded-1'
            width={60}
            height={60}
            src={imageUrl}
            data-testid={WatchItemTestIds.image}
          />
        </div>

        <div
          className={classNames(
            textContentClassName ? textContentClassName : 'mx-4',
            'd-flex flex-column justify-content-center fw-light gap-1 riforma-regular'
          )}
        >
          <div data-testid={WatchItemTestIds.title} className={classNames(titleClassName, 'fs-12px line-height-18px')}>
            {titleTruncated}
          </div>
          <div>{extraTitleInfo}</div>
        </div>
      </div>
      <div>{rightLabel}</div>
    </div>
  );
};
